import React from 'react';
import styles from './BlobContainer.module.scss';

const milliseconds = 1300;

const BlobContainer = ({ children, hide, className = '' }) => {

  const [delayHandler, setDelayHandler] = React.useState(null)

  const handleMouseOver = () => {
      clearTimeout(delayHandler)
  }

  const handleMouseOut = () => {
    
    const timeout = setTimeout(hide, milliseconds)
    setDelayHandler(timeout)
    
    return () => {
      clearTimeout(timeout);
    };
  }

  return (
    <div
      className={`${styles.container} ${className}`}
      onMouseEnter={handleMouseOver}
      onMouseLeave={handleMouseOut}
    >
      {children}
    </div>
  );
};

export default BlobContainer;
